import React from 'react';
import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

const BarsChart = () => {
  const options: ApexOptions = {
    chart: {
      type: 'bar',
      stacked: false,
      toolbar: { show: false },
      fontFamily: `'Poppins', sans-serif`,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '64%',
        borderRadius: 6,
        borderRadiusApplication: 'end',
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: ['#A78BFA', '#8B5CF6', '#6D28D9'],
    xaxis: {
      categories: ['OCDD', 'OAAS', 'EPSDT', 'ROW'],
      labels: {
        style: {
          fontSize: '1rem',
          fontFamily: `'Poppins', sans-serif`,
          colors: '#666666',
        },
      },
      axisTicks: {
        show: false, // <-- Hide x-axis ticks here
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: '1rem',
          fontFamily: `'Poppins', sans-serif`,
          colors: '#666666',
        },
      },
    },
    legend: {
      position: 'bottom',
      fontSize: '14px',
      markers: {
        size: 10,
        shape: 'circle',
      },
      fontFamily: `'Poppins', sans-serif`,
      labels: {
        colors: '#666666',
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      style: {
        fontFamily: `'Poppins', sans-serif`,
      },
    },
    grid: {
      borderColor: '#e7e7e7',
      strokeDashArray: 4,
    },
  };

  const series = [
    {
      name: 'Billable',
      data: [18000, 13000, 10000, 7000],
    },
    {
      name: 'Billed',
      data: [15000, 12000, 9000, 6000],
    },
    {
      name: 'Paid',
      data: [13500, 11000, 8500, 5500],
    },
  ];

  return (
    <div>
      <Chart
        options={options}
        series={series}
        type="bar"
        height={300}
      />
    </div>
  );
};

export default BarsChart;
